const env = window.ENV || process.env;

export default {
  REACT_APP_VERSION: "whisky",
  REACT_APP_API_ENDPOINT: env.REACT_APP_API_ENDPOINT,
  REACT_APP_GRAPHQL_ENDPOINT: env.REACT_APP_GRAPHQL_ENDPOINT,
  REACT_APP_ENABLE_DISPO_MAG: env.REACT_APP_ENABLE_DISPO_MAG,
  REACT_APP_ENABLE_DISPO_MAG_IF_COOKIE:
    env.REACT_APP_ENABLE_DISPO_MAG_IF_COOKIE,
  SENTRY: {
    DSN: env.REACT_APP_SENTRY_DSN,
    ENV: env.REACT_APP_SENTRY_ENV,
  },
  REACT_APP_ENVIRONMENT: env.REACT_APP_ENVIRONMENT,
  CMS: {
    ENDPOINT: env.REACT_APP_CMS_ENDPOINT || "",
  },
  T2S: {
    CID: env.REACT_APP_T2S_CID || "",
    RECO_PAGES:
      env.REACT_APP_ENVIRONMENT === "dev" ||
      env.REACT_APP_ENVIRONMENT === "staging"
        ? {
            HOME_NEWS: "1000-47",
            HOME_SELECTION: "1000-49",
            CART_PRODUCT_LIST: "1601-51",
            PRODUCT_FREE_AREA: "1200-53",
            PRODUCT_CUSTOM_ADVICES:
              "1000-47" /* TODO: replace by the correct space ID */,
            PRODUCT_ACCOMPAGNY_TASTING:
              "1000-49" /* TODO: replace by the correct space ID */,
            CATEGORY_EXPERT_ADVICES:
              "1000-49" /* TODO: replace by the correct space ID */,
            NOT_FOUND_PRODUCT_LIST: "3600-52",
          }
        : {
            HOME_NEWS: "1001-150",
            HOME_SELECTION: "1001-157",
            CART_PRODUCT_LIST: "1601-152",
            PRODUCT_FREE_AREA: "1202-158",
            PRODUCT_CUSTOM_ADVICES:
              "" /* TODO: replace by the correct space ID */,
            PRODUCT_ACCOMPAGNY_TASTING:
              "" /* TODO: replace by the correct space ID */,
            CATEGORY_EXPERT_ADVICES:
              "" /* TODO: replace by the correct space ID */,
            NOT_FOUND_PRODUCT_LIST: "3601-161",
          },
  },
  ALGOLIA: {
    KEY: env.REACT_APP_ALGOLIA_KEY || "",
    ID: env.REACT_APP_ALGOLIA_ID || "",
    ENV: env.REACT_APP_ALGOLIA_ENVIRONMENT || "",
  },
  ANALYTICS: {
    NETAFFILIATION_OLD: env.REACT_APP_ANALYTICS_NETAFFILIATION_OLD,
    NETAFFILIATION_NEW: env.REACT_APP_ANALYTICS_NETAFFILIATION_NEW,
    LENGOW_CUSTOMER_ID: env.REACT_APP_ANALYTICS_LENGOW_CUSTOMER_ID,
    LENGOW_GROUP_ID: env.REACT_APP_ANALYTICS_LENGOW_GROUP_ID,
  },
  GOOGLE: {
    MAP_API_KEY: env.REACT_APP_GOOGLE_MAP_API_KEY,
    RECAPTCHA_CLIENT_API_KEY:
      env.REACT_APP_GOOGLE_RECAPTCHA_CLIENT_API_KEY || "",
  },
};
